export default {
  newDesign: true,
  title:
    "Çocuklar için Matematik dersleri. ÜCRETSİZ deneme dersi alın | Kodland",
  downtimeUrl: "https://www.kodland.org/tr",
  parameters: {
    landing_id: "TrQMA",
    segment: 12,
  },
  stopPage: {
    image: "/welcome/quizV2/no-computer.png",
    title: "Eğitim platformumuza güvendiğiniz için teşekkür ederiz!",
    subtitle:
      "Maalesef, tablet veya telefonlar derslerimizi kullanmak için uygun değildir. Bir sonraki derslerimizde sizi görmekten mutluluk duyacağız!",
  },
  quizRotateBySteps: {
    1: {
      title: "Çocuğunuz kaç yaşında?",
      subtitle:
        "Burs değerlendirmesinde çocuğunuzun yaş grubu önemlidir. Lütfen yaşını seçin.",
      type: "age",
      button: "İleri 🚀",
    },
    2: {
      question:
        "Çocuğunuzun matematik, mantık veya aritmetik öğrenme deneyimi var mı?",
      answers: [
        "🏫 Evet, okulda matematik eğitimi aldı",
        "👨‍👩‍👧 Evet, kendi başına ya da ailesiyle çalıştı",
        "🧑‍🏫 Evet, kurslarda veya özel derslerde eğitim aldı",
        "😊 Hayır, henüz deneyimi yok",
      ],
    },
    3: {
      question: "Çocuğunuzun ilgi alanları nelerdir?",
      answers: [
        "🎮 Oyun tasarımı",
        "🤖 Kodlama",
        "🎬 Çizim ve animasyon",
        "🌐 Web tasarımı",
        "🧮 Mantık ve matematik",
        "✨ Henüz emin değilim, çeşitli seçenekleri keşfedelim",
      ],
    },
    4: {
      question: "Ücretsiz ilk dersten beklentiniz nedir?",
      answers: [
        "📊 Çocuğunun seviyesini öğrenmek",
        "🧩 Zorlandığı konuları görmek",
        "📈 Motivasyonunun artmasını sağlamak",
        "🎲 Matematiği oyunla öğrenmesini deneyimlemek",
      ],
    },
    5: {
      question:
        "Çocuğunuzun çalışabileceği bir masaüstü veya dizüstü bilgisayarınız var mı?",
      answers: [
        "💻 Evet",
        {
          answer: "😕 Hayır",
          stopAnswer: true,
        },
      ],
    },
    6: {
      title: "Son bir adım kaldı! 🎉",
      typeInfo: "congrats",
      subtitle:
        "Çocuğunuzun matematikte özgüven kazanmasına ve analitik düşünmesini geliştirmesine birlikte destek olalım.",
      button: "Hadi başlayalım!",
    },
    7: {
      title: "Ücretsiz ders rezervasyonu yapın",
      type: "one-page-contacts",
      subtitle: "",
      button: "Neredeyse bitti 🔥",
    },
    8: {
      title: "",
      type: "timeslot",
      subtitle: "",
      button: "",
    },
    9: {
      title: "Kaydı tamamlamak için bu bilgileri inceleyin ✨",
      typeInfo: "pc-laptop",
      subtitle:
        "Derse katılmak için lütfen masaüstü veya dizüstü bilgisayar kullanın ve ders boyunca çocuğunuza eşlik etmeyi unutmayın. Deneme dersinin bireysel ve kişiye özel olduğunu hatırlatmak isteriz.",
      button: "Başka neler var?",
    },
    10: {
      title:
        "Deneme dersinizden önce e-posta ve WhatsApp üzerinden iletişimde kalacağız. 📞",
      typeInfo: "whatsapp",
      subtitle:
        "Dersinizden 24 saat önce bir hatırlatma göndereceğiz ve 2 saat öncesinde katılımınızı onaylamanızı isteyeceğiz. İletişim kurmamız, dersinizin planlandığı gibi gerçekleşmesi için önemlidir.",
      button: "Başka neler var?",
    },
    11: {
      title: "Ders platformumuzda gerçekleşecek 💻",
      typeInfo: "classroom",
      subtitle:
        "WhatsApp ve e-posta yoluyla bir bağlantı ve özel bir kod alacaksınız. Sadece bağlantıya tıklayın, doğrudan derse yönlendirileceksiniz. Ekstra uygulama veya indirme gerekmiyor.",
      button: "Anladım ✅",
    },
  },
};
